<form [formGroup]="motivationRequestForm" class="form-container" (ngSubmit)="onSubmit()">
  <fieldset class="form-fieldset">
    <legend class="custom-legend">Motivation de la demande</legend>
    <div class="form-group">
      <div class="d-flex col-12 flex-column">
        <div class="row">
          <label for="motivation">Motivation de la demande@if (this.motivationRequestForm.get('motivation')?.hasValidator(ValidatorsRef.required)) {
            *
          }</label>
          <div class="form-text mb-1">Décrivez les raisons de la demande.</div>

          <mat-form-field class="expandable-textarea">
            <textarea style="height: 100px" [placeholder]="nbreCaratereTexte" matInput
            formControlName="motivation"></textarea>
            @if (motivationRequestForm.get('motivation')?.hasError('maxLengthExceeded')) {
              <mat-error>
                Le texte ne doit pas dépasser 720 caractères.
              </mat-error>
            }

            @if (motivationRequestForm.get('motivation')?.hasError('required') || motivationRequestForm.get('motivation')?.hasError('whitespace') && motivationRequestForm.get('motivation')?.touched) {
              <mat-error
                >
                Ce champ ne peut pas être vide ou contenir uniquement des espaces.
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="fichier-recommande">
        <p>
          Il est obligatoire de joindre le profil de poste et l'organigramme souhaités.
        </p>
      </div>
      <div class="download-container" [class.dragging]="isDragging" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" (drop)="handleDragDrop($event)">
        <label style="color: dimgray">Glissez-déposez les fichiers ici@if (this.motivationRequestForm.get('files')?.hasValidator(ValidatorsRef.required)) {
          *
        }</label>
        <mat-icon color="primary">upload</mat-icon>
        <input type="file" #fileInput (change)="onFileSelected($event)" accept="application/pdf" multiple hidden />
        <button mat-flat-button color="primary" (click)="triggerFileInput(fileInput)">Ou cliquez ici pour sélectionner
        les fichiers</button>
        @if (motivationRequestForm.get('files')?.hasError('required')) {
          <mat-error> Vous devez ajouter des pièces
          jointes. </mat-error>
        }
        @if (invalidFile) {
          <mat-error> Seuls les fichiers PDF sont autorisés. </mat-error>
        }
      </div>

      @if (selectedFileNames.length > 0) {
        <div class="file-name">
          <mat-chip-set class="custom-chip-list">
            @for (fileName of selectedFileNames; track fileName; let i = $index) {
              <mat-chip class="custom-chip"
                (removed)="removeFile(i)">
                {{ fileName.name }}
                <button matChipRemove aria-label="Supprimer la pièce jointe">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            }
          </mat-chip-set>
        </div>
      }
      <div class="file-size-warning">
        <p>
          La taille maximale d'un fichier ne doit pas dépasser <strong>300 MO *</strong><br />
          Seuls les fichiers au format <strong>PDF</strong> sont acceptés * <br />
        </p>
      </div>
    </div>
  </fieldset>
  <!-- btns -->
  <div class="button-group">
    <button mat-stroked-button type="button" (click)="onReset()"><mat-icon>autorenew</mat-icon>Réinitialiser</button>
    <button mat-stroked-button type="button" matStepperPrevious><mat-icon>undo</mat-icon>Précédent</button>
    <button mat-flat-button color="primary" type="submit" matStepperNext
    [disabled]="!motivationRequestForm.valid">Suivant</button>
  </div>
</form>
